//Include Both Helper File with needed methods
import {
  getVerifyEmail, postRegister,
} from "../../../helpers/auth_helper";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange, verifyEmailRequest, verifyEmailError, verifyEmailSuccess
} from "./reducer";


// Is user register successfull then direct plot user in redux.
export const registerUser = (user) => async (dispatch) => {
  try {
    let response;
      response = postRegister(user);
      const data = await response;
      if (data) {
        dispatch(registerUserSuccessful(data));
      } else {
        dispatch(registerUserFailed(data));
      }
  } catch (error) {
    console.log('e', error);
    dispatch(registerUserFailed(error));
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const apiError = () => {
  try {
    const response = apiErrorChange();
    return response;
  } catch (error) {
    return error;
  }
};

/**
 * Weryfikacja emaila przez token
 * @param {string} token - Token weryfikacyjny z emaila
 */
export const verifyEmail = (token) => async (dispatch) => {
  try {
    dispatch(verifyEmailRequest());
console.log('t', token);
    const response = await getVerifyEmail(token);

    if (response.success) {
      dispatch(verifyEmailSuccess(response.data));
    } else {
      dispatch(verifyEmailError(response.error || "Verification failed"));
    }
  } catch (error) {
    const errorMessage = error.response?.data?.error ||
      error.response?.data?.detail ||
      error.message ||
      "Email verification failed";
    dispatch(verifyEmailError(errorMessage));
  }
};
